import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        titlePrefix: "ETC Ellerau | ",
        title: 'Home',
        history: [],
        cookies: false,
        current_route_name: '',
        navigation_items: [
            {title: "Home", icon: "mdi-home", to: {name: 'home'}, bottom: false, drawer: true},
            { title: "Getränke-App", icon: "mdi-cart-outline", external: true, link: "https://app.etc-ellerau.de", bottom: true, drawer: true },
            {
                title: "Der Club",
                icon: "mdi-tennis",
                bottom: false,
                drawer: true,
                group: true,
                children: [
                    {
                        title: "Der Vorstand",
                        icon: "mdi-account-multiple",
                        to: {name: 'vorstand'}
                    },
                ]
            },
            {
                title: "50 Jahre - Jubiläum",
                icon: "mdi-account-group",
                to: { name: 'jubilaeum' },
                drawer: true,
            },
            {
                title: "Mannschaften",
                icon: "mdi-account-group",
                link: "https://slh.liga.nu/cgi-bin/WebObjects/nuLigaTENDE.woa/wa/clubTeams?club=35168",
                external: true,
                drawer: true,
            },

            {
                title: "Buchungen",
                icon: "mdi-clock",
                bottom: true,
                cookies: true,
                drawer: false,
                external: true,
                link: "https://etc-ellerau-v8.ebusy.de",
            },
            {
                title: "Buchungen", icon: "mdi-clock", bottom: false, drawer: true, group: true, children: [
/*                    {
                        title: "Aussenplätze",
                        icon: "mdi-white-balance-sunny",
                        to: {name: 'buchungen', params: {id: "aussenplaetze"}},
                        drawer: false
                    },
                    {
                        title: "Halle",
                        icon: "mdi-snowflake",
                        to: {name: 'buchungen', params: {id: "halle"}},
                        cookies: true,
                        drawer: false
                    },*/
                    {
                        title: "Ebusy Seite",
                        icon: "mdi-arrow-right",
                        external: true,
                        cookies: true,
                        link: "https://etc-ellerau-v8.ebusy.de",
                        drawer: false
                    },
                ]
            },
            {title: "Downloads", icon: "mdi-arrow-down", to: {name: 'downloads'}, drawer: true},
            {title: "Datenschutz", icon: "mdi-lock", to: {name: 'datenschutz'}, drawer: true},
            {title: "Impressum", icon: "mdi-file-document", to: {name: 'impressum'}, drawer: true}
        ],
        teams: [],
        downloads: [
            {
                name: 'Mitgliedschaft',
                children: [
                    {
                        link: 'aufnahmeantrag',
                        url: `/pdf/aufnahmeantrag_2026.pdf?v=${new Date().getTime()}`,
                        title: "Aufnahmeantrag",
                        route: "download"
                    },
                    {
                        link: 'beitragsordnung',
                        url: "/pdf/beitragsordnung_01_05_2024.pdf",
                        title: "Beitragsordnung",
                        route: "download"
                    },
                    {
                        link: 'hallenpreise',
                        url: `/pdf/hallenpreise.pdf?v=${new Date().getTime()}`,
                        title: "Hallenpreise 2026",
                        route: "download"
                    },
                    {
                        link: 'satzung',
                        url: "/pdf/Satzung.pdf",
                        title: "Satzung",
                        route: "download"
                    }
                ]
            },
            {
                name: 'Vereinsleben',
                children: [
                    {
                        link: 'bbi-open-2023',
                        url: '/pdf/bbi_open.pdf',
                        title: 'BBI Open 2023',
                        route: 'download'
                    },
                    {
                        link: 'verantwortung',
                        url: '/pdf/Verantwortlichkeiten_Aufgaben.pdf',
                        title: 'Verantwortlichkeiten und Aufgaben',
                        route: "download"
                    }
                ],
            },
            {
                name: 'Rechtliches',
                children: [
                    {
                        url: "/pdf/Datenschutzinformation.pdf",
                        title: "Datenschutzinformationen",
                        link: 'datenschutz',
                        route: "download"
                    }
                ]
            },
            {
                name: 'Kinderschutz',
                children: [
                    {
                        url: "/pdf/kinderschutz.pdf",
                        title: "Kinderschutzkonzept",
                        link: 'kinderschutz',
                        route: 'download'
                    }

                ]
            }
        ],
        projects: [],
        reports: [
            {
                name: 'Rückblicke',
                children: [
                    {
                        url: "/pdf/saison_rueckblick_2020.pdf",
                        title: "Saisonrückblick 2020",
                        link: "saison_2020",
                        route: "bericht"
                    },
                    {
                        url: "/pdf/saisonrueckblick_2017.pdf",
                        title: 'Saisonrückblick 2017',
                        link: 'saison_2017',
                        route: 'bericht'
                    },
                    {
                        url: "/pdf/saisonrueckblick_2016.pdf",
                        title: 'Saisonrückblick 2016',
                        link: 'saison_2016',
                        route: 'bericht'
                    }
                ]
            }
        ]
    },
    mutations: {
        SET_TITLE(state, value) {
            state.title = value
        },
        ADD_HISTORY(state, value) {
            state.history.push(value)
        },
        CURRENT_ROUTE(state, value) {
            state.current_route_name = value
        },
        ACCEPT_COOKIES(state, value) {
            state.cookies = value
        }
    },
    actions: {},
    getters: {},
    modules: {}
})

